import { useState } from "react"
import { ProductEntity } from "../../Objects/ProductsAndCatalogItems/ProductEntity"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { CatalogProductEntity } from "../../Objects/ProductsAndCatalogItems/CatalogProductEntity"
import { ETypeOfCharge } from "../../Enum/ETypeOfCharge"

export const useCreateProducts = () => {
  const [typeSelected, setTypeSelectChange] = useState<ETypeOfCharge>(ETypeOfCharge.FixedValue)

  const [products, setProducts] = useState<ProductEntity | null>(null)

  const handleInitialValue = (products: ProductEntity | null | undefined) => {
    if (products) {
      setProducts(products)
      setTypeSelectChange(products.typePayment)
    }
  }

  const handleSubmitForm = (catalogProductEntity: CatalogProductEntity): ProductEntity | { errors: ValidationError[] } => {
    return new ProductEntity({
      id: products?.id,
      typePayment: typeSelected,
      catalogProductEntity: catalogProductEntity!,
    })
  }

  return {
    products,
    typeSelected,
    setTypeSelectChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
